// Image transformation via wsrv.nl — a free, Cloudflare-fronted, open-source
// image proxy used by many production sites. It accepts the original image
// URL plus query params for width / format / quality and returns a freshly
// transcoded copy, cached at the edge. This lets us deliver WebP + responsive
// widths even though the source CDN (customer-assets.emergentagent.com) does
// not support format negotiation or width parameters natively.
//
// NOTE: wsrv.nl supports jpg / png / webp / tiff / gif / jxl — it does NOT
// currently support AVIF output. So we ship WebP as the modern format and
// JPG as the fallback. WebP @1200×q75 is ~3% the size of the raw originals
// in tests on this archive (1.1 MB → 37 KB).
//
// Source URL → wsrv URL:
//   imageSrc("https://customer-assets…/foo.jpg", 1200, "webp")
//   → "https://wsrv.nl/?url=https%3A%2F%2Fcustomer-assets…%2Ffoo.jpg&w=1200&output=webp&q=75"

const PROXY = "https://wsrv.nl/";

// Quality settings (kept perceptually identical on colour-rich paintings).
const QUALITY = {
  webp: 75,
  jpg: 80,
};

// Public production host — used to resolve relative /works/ paths so wsrv
// can fetch them. Falls back to the current origin client-side.
const PUBLIC_HOST = "https://www.rushitshah.com";

function absolutise(src) {
  if (!src) return src;
  if (/^https?:\/\//i.test(src)) return src;
  if (typeof window !== "undefined") return new URL(src, window.location.origin).toString();
  return PUBLIC_HOST + (src.startsWith("/") ? src : "/" + src);
}

export const RESPONSIVE_WIDTHS = [400, 800, 1200, 1800, 2400];

/**
 * Build a single transcoded image URL.
 * @param {string} src      Original source URL (absolute or /relative)
 * @param {number} width    Target width in pixels
 * @param {"webp"|"jpg"} format
 */
export function imageSrc(src, width, format = "jpg") {
  if (!src) return src;
  const original = absolutise(src);
  const params = new URLSearchParams({
    url: original,
    w: String(width),
    output: format,
    q: String(QUALITY[format] ?? 80),
    fit: "inside",
    il: "1",
  });
  return PROXY + "?" + params.toString();
}

/** Build a srcset string for the given format across all responsive widths. */
export function srcSetFor(src, format) {
  return RESPONSIVE_WIDTHS.map((w) => `${imageSrc(src, w, format)} ${w}w`).join(", ");
}
